module.exports = __webpack_public_path__ + "static/media/image_62.ca615957.png";